export default __webpack_public_path__ + "static/media/ch.a6d0c517.svg";